import React from 'react';

import Button from '@atlaskit/button/default/button';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Text } from '@atlaskit/primitives/compiled/text';
import Spinner from '@atlaskit/spinner/spinner';
import { PopupTrigger } from '@atlassian/entry-points/popup-trigger';

import { loadingPopupEntryPoint } from '../fixtures/constellation/loading-popup-entry-point';
import { RelayWrapper } from '../utils/wrapper';

function CustomLoading(): React.JSX.Element {
	return (
		<Box padding="space.200">
			<Inline space="space.100" alignBlock="center">
				<Spinner size="small" label="" />
				<Text>Preparing popup content</Text>
			</Inline>
		</Box>
	);
}

export default function PopupTriggerCustomLoading(): React.JSX.Element {
	return (
		<RelayWrapper>
			<PopupTrigger
				entryPoint={loadingPopupEntryPoint}
				role="dialog"
				label="Custom loading popup"
				placement="bottom-start"
				loadingText="Preparing popup content"
				loadingCompleteText="Popup content loaded"
				fallback={<CustomLoading />}
				trigger={(triggerProps) => (
					<Button {...triggerProps} appearance="primary" isSelected={triggerProps['aria-expanded']}>
						{triggerProps['aria-expanded'] ? 'Close popup' : 'Show custom loading'}
					</Button>
				)}
			/>
		</RelayWrapper>
	);
}
